<app-header [forceLightBackground]="true"></app-header>
<div class="compute-credit-home">
  <div class="compute-credit-home--layout">
    <app-admin-sidebar class="compute-credit-home--sidebar"></app-admin-sidebar>
    <div class="compute-credit-home--content">
      <app-page-header></app-page-header>
      <div class="compute-credit-container">
        <!-- Tabs -->
        <div class="tabs-container">
          <div class="tabs-header">
            <button 
              *ngFor="let tab of tabs"
              class="tab-button" 
              [class.active]="activeTab === tab.key"
              (click)="setActiveTab(tab.key)"
            >
              {{ tab.label }}
            </button>
          </div>

          <!-- Tab Content -->
          <div class="tab-content-wrapper">
            <div class="tab-panel" *ngIf="activeTab === 'compute-requests'">
              <app-user-compute-requests #userComputeRequests></app-user-compute-requests>
            </div>
            <div class="tab-panel" *ngIf="activeTab === 'credit-requests'">
              <app-user-credit-requests #userCreditRequests></app-user-credit-requests>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
